import { useEffect, useMemo } from "react";

import useApiRequestGet from "../../components/apiHooks/useApiRequestGet";
import {
	useCartActions,
	useCartContext,
} from "../../contexts/CartServiceContext/CartServiceContext";
import { useConfigActions, useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import { IConfigResponse } from "./types";

const HOST: string = process.env.CLOUD_RUN_GATEWAY_HOST ?? "";
const END_POINT: string = process.env.API_CONFIG ?? "";

const useGetConfig = () => {
	const { state: location } = useConfigContext((state) => state.location);
	const configActions = useConfigActions();
	const cartActions = useCartActions();
	const { state: cart } = useCartContext((state) => state);

	const url = useMemo(() => {
		if (!location?.id) {
			return null;
		}

		return `${HOST}${END_POINT}?uuid=${location.id}`;
	}, [location?.id]);

	const {
		data: response,
		isLoading,
		error,
	} = useApiRequestGet<IConfigResponse>({
		url,
		swrConfig: {
			revalidateOnFocus: false,
		},
	});

	useEffect(() => {
		if (!response) return;

		configActions.INIT_CONFIG(response.config);

		// Only set takeaway if user hasn't made a selection yet
		if (cart.initial_takeaway_selection) {
			cartActions.DINEIN();
		}
	}, [response, configActions, cartActions, cart.initial_takeaway_selection]);

	return {
		data: response,
		isLoading,
		error,
	};
};

export default useGetConfig;
